"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.qualifications = void 0;
const Matrix_1 = require("../../../TdWebtoolkitControls/controls/Matrix/Matrix");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const SynView_1 = require("../SynView");
class qualifications extends SynView_1.SynView {
    constructor() {
        super();
        this.m_hasMenu = false;
    }
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.icon = "fa-building-o";
    }
    renderContents() {
        let that = this;
        require.ensure(["./qualifications.less"], (require) => {
            require("./qualifications.less");
            that.m_$matrix = that.m_$container.find(".qualificationsMatrix");
            that.createMatrix();
        });
    }
    resizeControls() {
        if (this.m_$matrix)
            this.m_$matrix.synMatrix("resize", this.m_$container.innerWidth(), this.getAvailableHeightForMatrix());
    }
    forceRefresh(modifications) { }
    createMatrix() {
        let that = this;
        that.m_$matrix
            .on("initSuccess", () => {
            that.resizeControls();
        })
            .synMatrix({
            matrixId: "qualifications",
            rowClickMode: Matrix_1.RowClickMode.Properties,
            colClickMode: Matrix_1.ColumnClickMode.Properties,
            hoverHighlightingMode: Matrix_1.HighlightingMode.OnlyHeaders,
            width: that.m_$matrix.parent().innerWidth(),
            height: that.getAvailableHeightForMatrix(),
            cellRenderFunc: (physicalRowIdx, physicalColIdx, td, value, matrixData) => {
                var _a;
                td.innerHTML = "";
                if (value && value.value) {
                    let num = (value.value);
                    if (num > 3)
                        td.innerHTML = "V";
                    td.className += " trafficLight ";
                    if (num === 1 || num === 4) {
                        td.className += " green";
                        td.title = Utilities_1.synUtil.Strings.getValue("qualifications.qualifiedgreen");
                    }
                    else if (num === 2 || num === 5) {
                        td.className += " yellow";
                        td.title = Utilities_1.synUtil.Strings.getValue("qualifications.qualifiedyellow");
                    }
                    else if (num === 3 || num === 6) {
                        td.className += " red";
                        td.title = Utilities_1.synUtil.Strings.getValue("qualifications.qualifiedred");
                    }
                    if (num > 3)
                        td.title += " " + Utilities_1.synUtil.Strings.getValue("qualifications.deputy");
                    const daysRemaining = (_a = value.additionalData) === null || _a === void 0 ? void 0 : _a.qualificationDaysRemaining;
                    if (typeof daysRemaining !== "undefined") {
                        if (daysRemaining === 0) {
                            td.title += "\n" + Utilities_1.synUtil.Strings.getValue("qualifications.qualifiedyellowred");
                            td.className += " striped";
                        }
                        else
                            td.title += "\n" + kendo.format(Utilities_1.synUtil.Strings.getValue("qualifications.remainingdays"), daysRemaining);
                    }
                }
            }
        });
    }
    getAvailableHeightForMatrix() {
        if (!this.m_$matrix)
            return 0;
        let $parent = this.m_$matrix.parent();
        return $parent.innerHeight() - $parent.children(".headLine").outerHeight(true);
    }
}
exports.qualifications = qualifications;
